import type { ReturnRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseUpdateReturnStatusParams {
  onSuccess: (returnRequest: ReturnRequestDto) => void;
}

export default function useUpdateReturnStatus(
  params: UseUpdateReturnStatusParams,
) {
  return useApiMutation("patch", "/shops/{shopId}/return-requests/{returnRequestId}/status", {
    onSuccess(returnRequest) {
      params.onSuccess(returnRequest);
    },
  });
}
